export enum ProductTypeEnum {
  Simple,
  Composite,
}
